import { Mongo } from 'meteor/mongo';

export interface BotTerminalLine {
  _id: string;
  bot: string;
  entry: string;
  level: number;
  timestamp: Date;
}

export const BotTerminalLines = new Mongo.Collection<BotTerminalLine>('botTerminal');
